import React from 'react';
import { logError } from '../services/errorLogger';
import './ErrorBoundary.css';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    logError('ErrorBoundary', error, {
      severity: 'critical',
      componentStack: errorInfo?.componentStack,
    });
    this.setState({
      error,
      errorInfo,
    });
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary-container">
          <div className="error-content">
            <h1>😞 Something went wrong</h1>
            <p className="error-message">
              An unexpected error occurred. Don't worry, our team has been notified.
            </p>

            {process.env.NODE_ENV === 'development' && (
              <details className="error-details">
                <summary>Error Details (Development Only)</summary>
                <pre className="error-stack">
                  {this.state.error && this.state.error.toString()}
                </pre>
                <pre className="error-stack">
                  {this.state.errorInfo && this.state.errorInfo.componentStack}
                </pre>
              </details>
            )}

            <button className="error-reset-btn" onClick={this.handleReset}>
              Go to Home
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
